import { render, staticRenderFns } from "./CFormOOI.vue?vue&type=template&id=60fe3400&scoped=true&"
import script from "./CFormOOI.vue?vue&type=script&lang=js&"
export * from "./CFormOOI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fe3400",
  null
  
)

export default component.exports